module.exports = new __parcel__URL__("Thumbnail.d9124b79.svg").toString();